export default __webpack_public_path__ + "static/sports-massage-746ec9af1923633ae8d4eb89d67e9d8a.jpeg";